import { FC } from 'react';
import { noInventoryAvailable } from '../buyMessages';
import styles from './BuySharedNoInventoryAvailable.scss';

export const BuySharedNoInventoryAvailable: FC = () => (
    <div className={styles.noInventoryAvailable}>{noInventoryAvailable}</div>
);
